import { render, staticRenderFns } from "./AccreditationEdit.vue?vue&type=template&id=4ea8da30&scoped=true&"
import script from "./AccreditationEdit.vue?vue&type=script&lang=js&"
export * from "./AccreditationEdit.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationEdit.vue?vue&type=style&index=0&id=4ea8da30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea8da30",
  null
  
)

export default component.exports